import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import usePartenaires from "./hooks/usePartenaires";

import PartenaireDetails from "./components/PartenaireDetails";
import PartenaireDrawer from "./components/PartenaireDrawer";
import PartenaireForm from "./components/PartenaireForm";
import PartenairesGrid from "./components/PartenairesGrid";
import PartenairesHero from "./components/PartenairesHero";
import PartenairesStats from "./components/PartenairesStats";
import PartenairesToolbar from "./components/PartenairesToolbar";
import useScrollToTop from "../../../../hooks/useScrollToTop";

export default function Partenaires() {
  useScrollToTop();
  const {
    loading,
    saving,
    filters,
    setFilter,
    partenaires,
    filteredPartenaires,
    selectedPartenaire,
    drawerMode,
    deleteCandidateId,
    stats,
    actions,
  } = usePartenaires();

  return (
    <div className="space-y-6">
      <PartenairesHero
        loading={loading}
        total={partenaires.length}
        activeCount={stats.active}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshPartenaires}
      />

      <PartenairesStats loading={loading} stats={stats} />

      <PartenairesToolbar
        loading={loading}
        filters={filters}
        setFilter={setFilter}
        totalCount={partenaires.length}
        filteredCount={filteredPartenaires.length}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshPartenaires}
      />

      <PartenairesGrid
        loading={loading}
        partenaires={filteredPartenaires}
        deleteCandidateId={deleteCandidateId}
        onDetails={actions.openDetailsDrawer}
        onEdit={actions.openEditDrawer}
        onAskDelete={actions.askDelete}
        onCancelDelete={actions.cancelDelete}
        onConfirmDelete={actions.confirmDelete}
      />

      <PartenaireDrawer
        open={Boolean(drawerMode)}
        mode={drawerMode}
        partenaire={selectedPartenaire}
        onClose={actions.closeDrawer}
      >
        {drawerMode === "details" && selectedPartenaire && (
          <PartenaireDetails
            partenaire={selectedPartenaire}
            onEdit={() => actions.openEditDrawer(selectedPartenaire)}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "create" && (
          <PartenaireForm
            mode="create"
            saving={saving}
            onSubmit={actions.createPartenaire}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "edit" && selectedPartenaire && (
          <PartenaireForm
            mode="edit"
            partenaire={selectedPartenaire}
            saving={saving}
            onSubmit={actions.updatePartenaire}
            onClose={actions.closeDrawer}
          />
        )}
      </PartenaireDrawer>

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}